import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import { InvoiceApi, InvoiceNotExistError } from '../../../api'
import { FiatInvoice } from '../../../interfaces'

export const getInvoiceFiatAction = createAsyncThunk<
  FiatInvoice,
  string,
  { rejectValue: InvoiceNotExistError }
>('invoice/fiat/get', async (id, { rejectWithValue }) => {
  try {
    return await InvoiceApi.getFiat(id)
  } catch (e) {
    if (e instanceof InvoiceNotExistError) return rejectWithValue(e)
    throw e
  }
})

export const updateInvoiceFiatAction = createAsyncThunk(
  'invoice/fiat/update',
  async (params: Parameters<typeof InvoiceApi.updateFiat>[0]) => await InvoiceApi.updateFiat(params)
)

export const failInvoiceFiatAction = createAsyncThunk(
  'invoice/fiat/fail',
  async (params: Parameters<typeof InvoiceApi.failFiat>[0]) => await InvoiceApi.failFiat(params)
)

export const successInvoiceFiatAction = createAction('invoice/fiat/success')
